exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-switch.is-checked .el-switch__core{border-color:#c30d23;background-color: #c30d23}\n.el-button.is-plain:focus, .el-button.is-plain:hover{border-color:#c30d23;color: #c30d23}\n.el-color-picker__trigger{width: 22px;height: 22px;padding:0;}\n.el-color-picker{height: 22px;}", "", {"version":3,"sources":["/Users/switch/Documents/docker_z/src/gw_svn/trunk/gw_pc/static/css/index.css"],"names":[],"mappings":"AAAA,uCAAuC,qBAAqB,yBAAyB,CAAC;AACtF,qDAAqD,qBAAqB,cAAc,CAAC;AACzF,0BAA0B,YAAY,aAAa,UAAU,CAAC;AAC9D,iBAAiB,aAAa,CAAC","file":"index.css","sourcesContent":[".el-switch.is-checked .el-switch__core{border-color:#c30d23;background-color: #c30d23}\n.el-button.is-plain:focus, .el-button.is-plain:hover{border-color:#c30d23;color: #c30d23}\n.el-color-picker__trigger{width: 22px;height: 22px;padding:0;}\n.el-color-picker{height: 22px;}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./static/css/index.css
// module id = lIIw
// module chunks = 1